import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useMemo, } from 'react';
import theme from '../../styles/theme';
import { TextLink } from '../TextLink';
const defaultProps = {
    description: '',
    label: '',
    layout: 'condensed',
    learnMoreText: 'Learn more',
    name: 'optionSelectorHeading',
    onLearnMoreClick: undefined,
    price: undefined,
};
const OptionSelectorHeading = ({ description = defaultProps.description, isLoading, label = defaultProps.label, learnMoreText = defaultProps.learnMoreText, layout = defaultProps.layout, name = defaultProps.name, onLearnMoreClick = defaultProps.onLearnMoreClick, price = defaultProps.price, }) => {
    const descriptionStyles = useMemo(() => (css `
        ${theme.typeStyles.bodySmallStyles}
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        ${layout === 'condensed' && css `
          flex-shrink: 1;
        `}
        ${layout === 'expanded' && css `
          flex: 1;
        `}
      `), [
        layout,
    ]);
    const labelStyles = useMemo(() => (css `
        ${theme.typeStyles.titleAlternateMediumStyles}
        white-space: nowrap;
      `), []);
    const learnMoreStyles = useMemo(() => (css `
        ${layout === 'condensed' && css `
          display: inline-flex;
          flex-grow: 1;
          justify-content: flex-end;
          white-space: nowrap;
        `}
        ${layout === 'expanded' && css `
          width: 100%;
        `}
      `), [
        layout,
    ]);
    const priceStyles = useMemo(() => (css `
        ${theme.typeStyles.bodySmallStyles}
        ${theme.typeStyles.bodyBoldStyles}
        ${layout === 'expanded' && css `
          display: inline-flex;
          justify-content: flex-end;
        `}
        ${isLoading && css `
          color: ${theme.colors.textDisabled};
        `}
      `), [
        isLoading,
        layout,
    ]);
    const selectorDisplayStyles = useMemo(() => (css `
        align-items: baseline;
        column-gap: ${theme.spacing.base};
        display: flex;
        flex-wrap: wrap;
        row-gap: ${theme.spacing.x2};
        width: 100%;

        ${layout === 'condensed' && css `
          flex-wrap: nowrap;
        `}
      `), [
        layout,
    ]);
    const priceText = useMemo(() => (layout === 'expanded'
        ? price
        : `(${price})`), [
        layout,
        price,
    ]);
    return (_jsxs("div", Object.assign({ css: selectorDisplayStyles }, { children: [_jsx("div", Object.assign({ css: labelStyles }, { children: _jsx("span", { children: label }) })), _jsx("div", Object.assign({ css: descriptionStyles }, { children: _jsx("span", { children: description }) })), price
                && (_jsx("div", Object.assign({ "aria-label": `${name}Price`, css: priceStyles }, { children: priceText }))), onLearnMoreClick
                && (_jsx("div", Object.assign({ css: learnMoreStyles }, { children: _jsx(TextLink, { onClick: onLearnMoreClick, size: "small", text: learnMoreText || 'Learn more', type: "secondary" }) })))] })));
};
const MemoizedOptionSelectorHeading = memo(OptionSelectorHeading);
export { MemoizedOptionSelectorHeading as OptionSelectorHeading };
// MC-1068 Temporary hack for Storybook.
export default OptionSelectorHeading;
